import { Head } from 'common/components/Head';
import { getTranslation } from 'localization/helpers';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'styles/Button';
import { Company } from 'types/company';
import { Menu } from 'types/menu';
import { Meta } from 'types/meta';
import { Framework } from '../Framework';
import { NavigationButton } from '../NavigationButtons/NavigationButton';
import menuIcon from 'images/menuIcon.svg';
import arrowIcon from 'images/arrowIcon.svg';

export const LinkMenu: FC<{ menu: Menu; company: Company; meta: Meta }> = ({
  menu,
  company,
  meta
}) => {
  const { t, i18n } = useTranslation();
  const items = menu.menu_items;
  const [readyToRender, setReadyToRender] = useState<boolean>(false);

  useEffect(() => {
    if (items.length === 1) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const url = items[0].translations![i18n.language].url as string;
      window.location.replace(url);
    } else {
      setReadyToRender(true);
    }
  }, []);

  const title = getTranslation(
    company.translations,
    'title',
    i18n.language,
    meta.default_locale
  );
  const metaTitle = `${t('menu')} ${title}`;

  if (!readyToRender) return <div />;

  return (
    <Framework locales={meta.locales} logo={meta.logo} color={meta.color}>
      <Head title={metaTitle} description={metaTitle} />
      {items.map(item => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const localizedItem = item.translations![i18n.language];
        return (
          <Button
            onClick={() => {
              open(localizedItem.url as string, '_self');
            }}
          >
            <NavigationButton
              text={localizedItem.title}
              color={meta.color}
              icon={menuIcon}
              arrow={arrowIcon}
            />
          </Button>
        );
      })}
    </Framework>
  );
};
